
import {Platform} from "react-native";

// web端引入地图
function TMap(key) {
	return new Promise(function (resolve, reject) {
		window.init = function () {
			resolve(qq)
		}
		var script = document.createElement("script");
		script.type = "text/javascript";
		script.src = "https://map.qq.com/api/js?v=2.exp&libraries=convertor&callback=init&key="+key;
		script.onerror = reject;
		document.head.appendChild(script);
	})
}

// 定义web端头部
function setWebHeaderTitle(title) {
	if (Platform.OS === "web") {
		let header = document.getElementsByClassName("jd-header-new-title")[0] || document.getElementsByClassName("jd-header-title")[0] || "";
		header && (header.innerHTML = title);
	}
}

function screenRatio() {
	var width_screen=document.documentElement.clientWidth || window.screen.width;
	return width_screen/750;
}

function WebSwiperStyle() {
	// return new Promise(function (resolve, reject) {
	// 	window.init = function () {
	// 		resolve()
	// 	};
	// 	var cssLink = document.createElement("link");
	// 	cssLink.rel = "stylesheet";
	// 	cssLink.href = "https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.0.2/css/swiper.min.css";
	// 	cssLink.onerror = reject;
	// 	document.head.appendChild(cssLink);
	// })
	var cssLink = document.createElement("link");
	cssLink.rel = "stylesheet";
	cssLink.href = "https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.0.2/css/swiper.min.css";
	document.head.appendChild(cssLink);
}

// web 判断有没有登录
function WebIsLogin() {
	return new Promise((resolve, reject) => {
		fetch('https://api.m.jd.com/api?appid=nb-house&functionId=houseVerifylogin&body={}', {credentials: 'include'}).then(res => res.json()).then(res => {
			const { islogin } = res
			if(islogin){
				resolve()
			}else{
				reject()
			}
		})
	})
}

// web 去登陆
function WebToLogin(returnurl = location.href) {
	returnurl = encodeURIComponent(returnurl)
	window.location.href = 'https://plogin.m.jd.com/user/login.action?appid=243&returnurl=' + returnurl
}

// Web获取Cookie
function WebGetCookie(name) {
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	if (arr = document.cookie.match(reg)) {
			return unescape(arr[2]);
	} else {
			return '';
	}
}
function isWebIos() {
	const ua = (navigator && navigator.userAgent) || '';
	return ua.indexOf('like Mac OS X') > -1
}
function isWebAndroid() {
	const ua = (navigator && navigator.userAgent) || '';
	return  ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
  }

export {
	TMap,
	setWebHeaderTitle,
	WebSwiperStyle,
	WebIsLogin,
	WebToLogin,
	WebGetCookie,
	isWebIos,
	isWebAndroid
}